import { Row } from 'antd';
import HamburgerMenu from '../../Atoms/HamburgerMenu';
import Styles from './SidebarMenuButton.module.scss';
import { TSidebarMenuButtonProps } from './definitions';

function SidebarMenuButton({ onClick }: TSidebarMenuButtonProps) {
  return (
    <Row
      align="middle"
      className={Styles['sidebar-menu-button']}
      onClick={onClick}
    >
      <HamburgerMenu />
    </Row>
  );
}

export default SidebarMenuButton;
